var IncrementalSearch = function(searchInput, resultsContainer) {
  this.searchInput = searchInput;
  this.resultsContainer = resultsContainer;
  this.cachedResults = new Map(); 
  this.currentQuery = '';
  this.debounceTimer = null;
  this.init();
};

IncrementalSearch.prototype.init = function() {
  this.searchInput.addEventListener('input', this.handleInput.bind(this));
};

IncrementalSearch.prototype.handleInput = function() {
  var query = this.searchInput.value.trim();
  clearTimeout(this.debounceTimer);
  this.debounceTimer = setTimeout(function() {
    this.performSearch(query);
  }.bind(this), 300);
};

IncrementalSearch.prototype.performSearch = function(query) {
  if (query.length < 2) {
    this.clearResults();
    return;
  }
  if (this.cachedResults.has(query)) {
    this.updateResults(this.cachedResults.get(query));
    return;
  }
  this.fetchSearchResults(query)
    .then(function(results) {
      this.cachedResults.set(query, results);
      this.updateResults(results);
    }.bind(this))
    .catch(function(error) {
      console.error('Search failed:', error);
      this.clearResults();
    }.bind(this));
};

IncrementalSearch.prototype.fetchSearchResults = function(query) {
  // Add a loading state
  this.resultsContainer.classList.add('is-loading');

  return fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product', {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    }
  })
  .then(function(response) {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(function(data) {
    // Remove loading state
    this.resultsContainer.classList.remove('is-loading');
    return this.transformSearchResults(data);
  }.bind(this))
  .catch(function(error) {
    // Remove loading state on error
    this.resultsContainer.classList.remove('is-loading');
    console.error('Search failed:', error);
    this.clearResults();
    throw error;
  }.bind(this));
};

IncrementalSearch.prototype.transformSearchResults = function(data) {
  var products = (data.resources && data.resources.results && data.resources.results.products) || [];
  
  return {
    products: products.map(function(product) {
      return {
        id: product.id,
        title: product.title,
        url: product.url,
        image: (product.featured_image && product.featured_image.src) || '',
        price: product.price_min || ''
      };
    }),
    collections: [],
    pages: []
  };
};

IncrementalSearch.prototype.updateResults = function(results) {
  var productItemsContainer = this.resultsContainer.querySelector('.search-flydown--product-items ul');
  
  if (!productItemsContainer) {
    console.error('Product items container not found');
    return;
  }

  if (results.products.length === 0) {
    this.showNoResultsMessage();
    return;
  }

  // Create a document fragment to minimize reflows
  var fragment = document.createDocumentFragment();
  
  results.products.forEach(function(product) {
    var productElement = this.createProductElement(product);
    fragment.appendChild(productElement);
  }.bind(this));

  // Single DOM update
  productItemsContainer.innerHTML = '';
  productItemsContainer.appendChild(fragment);

  // Ensure the results container remains visible
  this.resultsContainer.classList.add('visible');
};

IncrementalSearch.prototype.createProductElement = function(product) {
  var productElement = document.createElement('li');
  productElement.innerHTML = `
    <a class="search-flydown--product" href="${product.url}" aria-label="${product.title}">
      <figure class="search-flydown--product-image">
        <img src="${product.image}" alt="${product.title}">
      </figure>
      <div class="search-flydown--product-details">
        <span class="search-flydown--product-title">${product.title}</span>
        <span class="search-flydown--product-price">${product.price}</span>
      </div>
    </a>
  `;
  return productElement;
};

IncrementalSearch.prototype.showNoResultsMessage = function() {
  var productItemsContainer = this.resultsContainer.querySelector('.search-flydown--product-items');
  
  if (productItemsContainer) {
    productItemsContainer.innerHTML = [
      '<div class="no-results">',
      '  No products found for your search.',
      '</div>'
    ].join('');
    this.resultsContainer.classList.add('visible');
  }
};

IncrementalSearch.prototype.clearResults = function() {
  var productItemsContainer = this.resultsContainer.querySelector('.search-flydown--product-items');
  
  if (productItemsContainer) {
    productItemsContainer.innerHTML = '';
    this.resultsContainer.classList.remove('visible');
  }
};

document.addEventListener('DOMContentLoaded', function() {
  var searchInput = document.querySelector('input[name="q"]');
  var resultsContainer = document.querySelector('.search-results');
  
  if (searchInput && resultsContainer) {
    new IncrementalSearch(searchInput, resultsContainer);
  }
});